module.exports = __webpack_public_path__ + "static/media/frp2.991dd2e9.png";